import { Alert, AlertLevel } from '@vizit/atoms';

interface SparkErrorProps {
  /**
   * The error title to display
   * @default "There was a problem loading Spark"
   */
  title?: string;
  /**
   * The error message to display
   * @default "Please try again later"
   */
  message?: string;
}

/**
 * Error state component for Spark
 * Displays when there's an error loading Spark recommendations
 */
export const SparkError = (props: SparkErrorProps) => {
  const { title = 'There was a problem loading Spark', message = 'Please try again later' } = props;

  return (
    <div className="flex flex-col justify-start items-center h-full gap-8 lg:justify-center">
      <Alert level={AlertLevel.Error}>
        <Alert.Title>{title}</Alert.Title>
        <Alert.Description>{message}</Alert.Description>
      </Alert>
    </div>
  );
};
